import React, { useState, } from 'react';
import { Form, Input, Button, Row, Typography, Space, Alert, } from 'antd';
import { useApp } from '../../context/app-context';
import { useNavigate } from "react-router-dom"
import { UserOutlined, LockOutlined, } from '@ant-design/icons';
import PCI_DSS_validated_logo from '../../../src/assets/PCI_DSS_Validated.png';
import { login } from '../../services/AuthService';
import { LOGIN_VERSION, USER_TYPE } from '../../Constants';
import './Auth.css';
import { useMessage } from '../../components/UI/MessageProvider';

const { Text, Title, Link } = Typography;

export const Login = ({version, enable2FA, setEnable2FA, ...props}) => {

    const { dispatch } = useApp();
    const navigate = useNavigate();

    const message = useMessage();

    const [failedAuthMessage, setFailedAuthMessage] = useState(false);


    const onFinish = (values) => {
        
        login(values).then( function(data) {
            if (data.success) {
                setFailedAuthMessage(false);
                if((data.userType === USER_TYPE.CUSTOMER) && (version === LOGIN_VERSION.cloud1x)){
                    setEnable2FA(data);
                    navigate('/verify-code')
                    return
                } else {
                    dispatch({type: 'update-user', payload: data})
                    dispatch({type: 'login', payload: true})
                    message.success('Welcome back!', 5);
                    return;
                }
            } else if(data && !data.success){
                setFailedAuthMessage(data.message)
            } else {
                setFailedAuthMessage('Invalid username or password.')
            }
        })
    };

    return (
        <>
            <Row className="login-container">
                <Form
                    name="login"
                    className="form-container"
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    size='default'
                    autoComplete='off'
                    onValuesChange={() => setFailedAuthMessage(false)}
                >   
                    <Title level={1}>Log in</Title>

                    { (failedAuthMessage && failedAuthMessage !== '') &&
                        <Alert style={{marginBottom: 24, border: 0}} message={<Text type='danger'>{failedAuthMessage}</Text>} type='error' showIcon/>
                    }

                    <Form.Item
                        name="username"
                        rules={[{ required: true, message: "Username is required" }]}
                    >
                        <Input 
                            prefix={<UserOutlined/>}
                            placeholder="Username"
                        />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: "Password is required" }]}
                    >
                        <Input.Password
                            prefix={<LockOutlined/>}
                            type="password"
                            placeholder="Password"
                            autoComplete='off'
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" block className="login-form-button btn-block">Login</Button>
                        {/* Or <a href="">register now!</a> */}
                    </Form.Item>

                    <Form.Item>
                        <Row justify="end">
                        <Space direction='vertical' style={{textAlign: 'right', }}>
                            <Link strong onClick={() => navigate('/forgot-password')}>Forgot your password?</Link>
                            
                            { version === LOGIN_VERSION.cloud1x &&
                                <Text align="center">Don't have an account? <Link onClick={() => navigate('/signup')}><strong>Sign up</strong></Link></Text>
                            }

                            </Space>
                        </Row>
                    </Form.Item>
                </Form>
            </Row>

            <Row justify='center'>
                <img alt='PCI DSS Validated Logo' src={PCI_DSS_validated_logo} style={{pointerEvents: 'none'}}></img>
            </Row>
        </>
    )
}
